/* unplugin-vue-components disabled */import { render } from "./lottieAnimation.vue?vue&type=template&id=365f5a3e&scoped=true"
import script from "./lottieAnimation.vue?vue&type=script&lang=js"
export * from "./lottieAnimation.vue?vue&type=script&lang=js"

import "./lottieAnimation.vue?vue&type=style&index=0&id=365f5a3e&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-365f5a3e"]])

export default __exports__